// Url retrieval function
window.baseUrl = function(path) {
    let basePath = document.querySelector('meta[name="base-url"]').getAttribute('content');
    if (basePath[basePath.length-1] === '/') basePath = basePath.slice(0, basePath.length-1);
    if (path[0] === '/') path = path.slice(1);
    return basePath + '/' + path;
};

window.importVersioned = function(moduleName) {
    const version = document.querySelector('link[href*="/dist/styles.css?version="]').href.split('?version=').pop();
    const importPath = window.baseUrl(`dist/${moduleName}.js?version=${version}`);
    return import(importPath);
};

// Set events and http services on window
import events from "./services/events"
import httpInstance from "./services/http"
window.$http = httpInstance;
window.$events = events;

// Translation setup
// Creates a global function with name 'trans' to be used in the same way as Laravel's translation system
import Translations from "./services/translations"
const translator = new Translations();
window.trans = translator.get.bind(translator);
window.trans_choice = translator.getPlural.bind(translator);
window.trans_plural = translator.parsePlural.bind(translator);

// Load Components
import components from "./components"
components();
//
//
//
var kat_toggle = false;
var menu_toggle = false;
var kat_toggle_link = document.getElementById('kategoriak');
var bilaform = document.getElementById('bilaform');
var term = document.getElementById('term');
var kat_nav = document.getElementById('kat_nav');
var menu = document.getElementById('menumobile');
var nav = document.getElementById('mainnav');

var onMenu = (e) => {
	if(!menu_toggle) {
		//open it
		menu_toggle = true;
		nav.style.display = 'block';
	} else {
		menu_toggle = false;
		nav.style.display = 'none';
	
	}
}
var onKat = (e) => {
	if(!kat_toggle) {
		//open it
		kat_toggle = true;
		kat_nav.style.display = 'block';
	} else {
		kat_toggle = false;
		kat_nav.style.display = 'none';
	
	}
}
let onBila = (e) => {
	e.preventDefault();
	window.location.href = '/bilatu?term=' + term.value;
}
window.onload = () => {
	if (kat_toggle_link) {
	kat_toggle_link.addEventListener("click", onKat)
	}
	if (menu) {
	menu.addEventListener("click", onMenu)
	}
	if (bilaform) {
	bilaform.addEventListener("submit", onBila)
	}
}
